<obg-m-success-animation-component></obg-m-success-animation-component>
<h1 class="title" [innerHTML]="titleText | translate"></h1>
<form data-test-id="login-consents.communications" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
	<ng-container *ngIf="!isOneTrustEnabled else simplifiedConsents">
		<ng-container *ngIf="marketingConsentEnabled && missingMarketingConsents">
			<mat-card
				class="obg-m-consent-item"
				test-id="login-consents.communications"
				*ngIf="(missingMarketingConsents!.brandMarketing || missingMarketingConsents!.groupMarketing) && !hideGroupConsent"
			>
				<mat-card-title>
					<h2 [innerHtml]="'login-consents.communications.title' | translate"></h2>
					<div>
						<h3 [innerHtml]="captionKey | translate"></h3>

						<mat-button-toggle-group
							name="formGroup.controls.communications"
							formControlName="communications"
							(change)="uiInteractionFieldEvent('communications')"
						>
							<mat-button-toggle [value]="true" test-id="consent-item.yes"
								>{{ "general.yes" | translate }}</mat-button-toggle
							>
							<mat-button-toggle [value]="false" test-id="consent-item.no"
								>{{ "general.no" | translate }}</mat-button-toggle
							>
						</mat-button-toggle-group>
					</div>
				</mat-card-title>
				<mat-card-content
					*ngIf="formGroup.controls.communications.value && missingMarketingConsents!.brandMarketing"
				>
					<mat-expansion-panel
						[expanded]="formGroup.controls.communications.value && missingMarketingConsents!.brandMarketing"
						class="mat-elevation-z0"
					>
						<mat-panel-description>
							<p>{{ 'marketing-settings.marketing.notifications.caption' | translate }}</p>
							<obg-m-marketing-notifications
								[formGroup]="subscriptionsFormGroup"
								(change)="uiInteractionFieldEvent($event)"
							>
							</obg-m-marketing-notifications>
						</mat-panel-description>
					</mat-expansion-panel>
				</mat-card-content>
			</mat-card>
		</ng-container>
		<mat-card
			class="obg-m-consent-item"
			test-id="login-consents.cookies"
			*ngIf="shouldAskCookieConsent && !!missingMarketingConsents?.cookie"
		>
			<mat-card-title>
				<h2 [innerHTML]="'login-consents.cookies.title' | translate"></h2>
				<div>
					<h3 [innerHTML]="'login-consents.cookies.caption' | devicePostfix | translate"></h3>
					<mat-button-toggle-group
						name="formGroup.controls.cookie"
						formControlName="cookie"
						(change)="uiInteractionFieldEvent('cookies')"
					>
						<mat-button-toggle [value]="true" test-id="consent-item.yes"
							>{{ "general.yes" | translate }}</mat-button-toggle
						>
						<mat-button-toggle [value]="false" test-id="consent-item.no"
							>{{ "general.no" | translate }}</mat-button-toggle
						>
					</mat-button-toggle-group>
				</div>
			</mat-card-title>
		</mat-card>
		<button
			mat-flat-button
			color="primary"
			[disabled]="isSubmitButtonDisabled || isLoading"
			test-id="login-consent-submit-btn"
		>
			<span *ngIf="!isLoading; else loading">{{ "login-consents.submit" | translate }}</span>
			<ng-template #loading>
				<mat-spinner diameter="20"></mat-spinner>
			</ng-template>
		</button>
	</ng-container>
	<p class="consent-disclaimer">{{ "login-consents.disclaimer" | translate }}</p>
</form>

<ng-template #simplifiedConsents>
	<h3 class="card-title" [innerHtml]="'login-consents.communications.title' | translate"></h3>
	<h3 class="card-text" [innerHtml]="captionKey | translate"></h3>
	<div class="consent-controls">
		<button
			(click)="setMarketingConsent(false)"
			[disabled]="isLoading"
			mat-flat-button
			color="secondary"
			test-id="login-consent-decline-btn"
			data-test-id="login-consent-decline-btn"
		>
			{{ declineKey | translate }}
		</button>
		<button
			(click)="setMarketingConsent(true)"
			[disabled]="isLoading"
			mat-flat-button
			color="primary"
			test-id="login-consent-accept-btn"
			data-test-id="login-consent-accept-btn"
		>
			{{ acceptKey | translate }}
		</button>
	</div>
</ng-template>
